// Token storage abstraction. The JWT is issued by the GraphQL auth mutations and sent as
// a Bearer header on every request. The web app uses localStorage; the Chrome extension
// swaps in a chrome.storage-backed store (bridged through a sync in-memory cache) via
// configureTokenStore — so the shared GraphQL client/api.ts work unchanged in both.
export const TOKEN_KEY = 'promptioso.token'

export interface TokenStore {
  get(): string | null
  set(token: string): void
  clear(): void
}

const localStorageStore: TokenStore = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (token) => localStorage.setItem(TOKEN_KEY, token),
  clear: () => localStorage.removeItem(TOKEN_KEY),
}

let store: TokenStore = localStorageStore

// Called once at startup by a non-web host (the extension) to replace the backend.
export function configureTokenStore(custom: TokenStore): void {
  store = custom
}

export function getToken(): string | null {
  return store.get()
}

export function setToken(token: string): void {
  store.set(token)
}

export function clearToken(): void {
  store.clear()
}

export function isAuthenticated(): boolean {
  return getToken() !== null
}
